// Utils
import traverse from 'fc-utils/traverse'

// Local Selectors
export default traverse(['mapModule', 'panelToggled', Boolean])
